import CategoryPage from "@/pages/category/components/CategoryPage";
import { getArticlesByCategory } from "@/mocks/articles";

export default function LiandongQingbao() {
  return (
    <CategoryPage
      categorySlug="liandong-qingbao"
      metaTitle="联动情报 - 游戏×IP联动追踪 | 可游漫画网"
      metaDesc="可游漫画网联动情报栏目，追踪游戏与动画、漫画IP跨界合作动态，跟进联动主题漫画与活动内容，热门联动情报一站掌握。"
      heading="联动情报"
      kicker="跨界追踪"
      articles={getArticlesByCategory("liandong-qingbao")}
    />
  );
}